import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { isSilentObserver } from "../../../../../shared/utility";
import { setRemoteParticipanteAudioVideoStatus } from "../../../Room/roomFunction";
import { attachTracks, getTracksByType } from "../../../twilioCallUtility";
import audioTranslationService from "../../../../../services/audioTranslationService";

export const handleAudioTrackSubscribedInRoom = (track, participant) => {
    if (GLOBAL_MEETING_DATA.isAgent) {
        handleAudioTrackSubscribed(track, participant);
    }

    // for the guest and SO user
    if (!GLOBAL_MEETING_DATA.isAgent) {
        if (isSilentObserver(participant.identity)) {
            console.log("Silent observer audio track not subscribe for the guest and silent observer user");
            // do nothing
        } else {
            handleAudioTrackSubscribed(track, participant);
        }
    }
};

export const handleAudioTrackSubscribed = (track, participant) => {
    const previewContainer = document.getElementById("audioTag");
    const trackArray = getTracksByType(participant, "audio");
    console.log("::in trackPublished attachArray: ", trackArray);
    attachTracks(trackArray, previewContainer);
    if (GLOBAL_MEETING_DATA.isAgent) {
        if (participant.identity != CALL_DATA.localIdentity) {
            setRemoteParticipanteAudioVideoStatus("audio", participant.identity, track.isEnabled);
        }
    }
    // Notify audio translation service of new remote audio track
    audioTranslationService.onRemoteAudioTrackSubscribed(track, participant.identity);
};
